import { BookingStoreNamespace } from "../modules/booking/store";
import { BOOKING_URL } from "./common-urls";
import { MHTTPCL } from "./http/http-client";
import { HttpLib } from "./http/http-lib";


const DETAILS_GPT_PROD_URL = "https://aicr.details-ai.com";
const DETAILS_GPT_LOCAL_URL = "http://localhost:3000";

// const DETAILS_GPT_BASE_URL = DETAILS_GPT_PROD_URL;
// const DETAILS_GPT_BASE_URL = DETAILS_GPT_LOCAL_URL;
const DETAILS_GPT_BASE_URL = process.env.NODE_ENV === 'production' ? DETAILS_GPT_PROD_URL : DETAILS_GPT_LOCAL_URL;

const postJson = async (url, data) => {
  return await HttpLib.post(url, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => res.data);
}
const getJson = async (url) => {
  return await HttpLib.get(url).then(res => res.data);
}

export const DtGPTService = {
  getAllMessages: async () => {
    return await getJson(`${DETAILS_GPT_BASE_URL}/api/chats`);
  },
  sendNewMessage: async (text, context) => {
    return await postJson(`${DETAILS_GPT_BASE_URL}/api/chats`, { text, context });
  },
  sendChatMessage: async (chatId, text, context) => {
    return await postJson(`${DETAILS_GPT_BASE_URL}/api/chats/${chatId}`, { text, context });
  },
  sendNewConversationMessage: async (text, context) => {
    return await postJson(`${DETAILS_GPT_BASE_URL}/api/conversations`, { text, context });
  },
  sendConversationMessage: async (chatId, text, context) => {
    return await postJson(`${DETAILS_GPT_BASE_URL}/api/conversations/${chatId}`, { text, context });
  },
  sendCommandFind: async (text, context, messages = []) => {
    return await postJson(`${DETAILS_GPT_BASE_URL}/api/commands/find`, { text, context, messages });
  },
  sendCommandFill: async (text, context, messages = []) => {
    return await postJson(`${DETAILS_GPT_BASE_URL}/api/commands/fill`, { text, context, messages });
  },
  nameConversation: async (text) => {
    return await postJson(`${DETAILS_GPT_BASE_URL}/api/commands/name`, { text });
  },


  // /ai.pl?section=gpt_conversation&action=add_conversation&title=safiqul%20test%201%20Data%20চেক&conversation_section=Contacts&message_json_str=Hi%20আই

  addConversation: async (title, conversation_section, message_json_str) => {
    return MHTTPCL.post2('/ai.pl', {
      section: 'gpt_conversation',
      action: 'add_conversation',
      title,
      conversation_section,
      message_json_str,
    });
  },

  // modify.pl?kVal=1&name=title&value=new-title&table=ai_conversations
  modifyConversationTitle: async (conversation_id, title) => {
    return MHTTPCL.get2('/modify.pl', {
      kVal: conversation_id,
      name: 'title',
      value: title,
      table: 'ai_conversations'
    });
  },





  // /ai.pl?section=gpt_conversation&action=add_message&conversation_id=7&message_json_str={}

  addMessageToConversation: async (conversation_id, message_json_str) => {
    return MHTTPCL.post2('/ai.pl', {
      section: 'gpt_conversation',
      action: 'add_message',
      conversation_id,
      message_json_str
    });
  },

  // /ai.pl?section=gpt_conversation&action=conversations

  getAllConversations: async () => {
    return MHTTPCL.get2('/ai.pl', {
      section: 'gpt_conversation',
      action: 'conversations'
    });
  },

  // /ai.pl?section=gpt_conversation&action=conversations&conversation_id=10

  getConversation: async (conversation_id) => {
    return MHTTPCL.get2('/ai.pl', {
      section: 'gpt_conversation',
      action: 'conversations',
      conversation_id
    });
  },


  // /ai.pl?section=gpt_conversation&action=remove_conversation&conversation_id=10

  deleteConversation: async (conversation_id) => {
    return MHTTPCL.get2('/ai.pl', {
      section: 'gpt_conversation',
      action: 'remove_conversation',
      conversation_id
    });
  }
}




export const DtGPTStoreService = {
  getContext: (route, getters) => {
    // Get pk from router name calendar_date_id
    const routeParts = route.name?.split("/");

    const primaryKey = routeParts?.[2] === "tab" ? routeParts?.[1] : '';
    const primaryKeyValue = route.params?.[primaryKey];


    // path = /main/booking/booking_list/295/overview
    const moduleRoute = route.path.split("/")[2];
    console.log({ 'dt-gpt.service.js:49 moduleRoute': moduleRoute });

    // const storeNS = {
    //   booking: BookingStoreNamespace
    // }[moduleRoute];

    // const entityDetailsGetterKey = {
    //   calendar_date_id: 'bookingDetails',
    // }[primaryKey];

    // const context = getters[`${storeNS}/${entityDetailsGetterKey}`]?.[primaryKeyValue];

    // const storeTree = {
    //   booking: {
    //     namespace: BookingStoreNamespace,
    //     entityDetailsGetterKey: {
    //       calendar_date_id: 'bookingDetails',
    //     }
    //   }
    // };

    // const storeNS = storeTree[moduleRoute]?.namespace;
    // console.log({'dt-gpt.service.js:71 storeTree' : storeTree});
    // console.log({'dt-gpt.service.js:70 storeNS' : storeNS});

    // const entityDetailsGetterKey = storeTree?.[moduleRoute]?.entityDetailsGetterKey?.[primaryKey];
    // console.log({'dt-gpt.service.js:73 entityDetailsGetterKey' : entityDetailsGetterKey});

    // const context = getters[`${storeNS}/${entityDetailsGetterKey}`]?.[primaryKeyValue];
    console.log({ primaryKey, primaryKeyValue });
    console.log({ 'dt-gpt.service.js:83 route': route });


    const getterKey = findGettersFromRoute(route.name);

    const context = primaryKey ? getters?.[getterKey]?.[primaryKeyValue] : getters?.[getterKey];
    console.log({ 'dt-gpt.service.js:85 context': context });


    return JSON.stringify(context);
  },
  getContext2: (route, getters, getterKey, mapper) => {
    // Get pk from router name calendar_date_id
    const routeParts = route.name?.split("/");

    const primaryKey = routeParts?.[2] === "tab" ? routeParts?.[1] : '';
    const primaryKeyValue = route.params?.[primaryKey];
    
    const context = primaryKey ? getters?.[getterKey]?.[primaryKeyValue] : getters?.[getterKey];



    return JSON.stringify(mapObject(context, mapper));
  }
}




export const GPTContextService = {
  ArtistService: {
    getAllArtistIDNames: async () => {
      return MHTTPCL.get(BOOKING_URL, {
        section: 'artist'
      }).then(res => res.data.all_artist?.map(e => {
        return {
          artist_id: e.artist_id,
          artist_name: e.artist_name
        }
      }));
    }
  }
}


const routeGetterMap = {
  'invoices/invoice_id': ['accounting', 'AccountingStore', 'invoiceList', 'invoiceDetails', 'InvoiceDetails', 'invoice_id'],
  'invoice_reminders/invoice_reminder_id': ['accounting', 'AccountingStore', 'invoiceReminderList', 'selectedInvoiceReminder'],
  'costs/invoice_id': ['accounting', 'AccountingStore', 'costsList', 'costsDetails', 'CostsDetails', 'invoice_id'],
  'booking_list/calendar_date_id': ['booking', 'BookingStore', 'bookingArtistList', 'bookingDetails', 'BookingDetails', 'calendar_date_id'],
  'booking_calendar/calendar_date_id': ['booking', 'BookingStore', 'filteredCalendarBookingList', 'calendarDate'],
  'venues/venue_id': ['booking', 'BookingStore', 'venueList', 'selectedVenue', 'VenueDetails', 'venue_id'],
  'artists/artist_id': ['booking', 'BookingStore', 'artists', 'selectedArtist', 'ArtistDetails', 'artist_id'],
  'promoters/promoter_id': ['booking', 'BookingStore', 'bookingPromoters', 'promoterDetails', 'PromoterDetails', 'promoter_id'],
  'templates/booking_template_id': ['booking', 'BookingStore', 'bookingTemplates', 'templateDetails', 'TemplateDetails', 'booking_template_id'],
  'contact_list/contact_id': ['contacts', 'ContactStore', 'contactsData', 'selectedContact', 'ContactDetails', 'contact_id'],
  'groups/group_id': ['contacts', 'ContactStore', 'contactGroups', 'selectedContactGroup', 'ContactGroupDetails', 'group_id'],
  'files/file_id': ['contacts', 'ContactStore', 'contactFiles', 'contactFilesSearchResult'],
  'identities/invoice_project_id': ['settings', 'SettingsStore', 'invoiceProjects', 'invoiceProjectDetails', 'InvoiceProjectDetails', 'invoice_project_id'],
  'users/user_id': ['settings', 'SettingsStore', 'userlist', 'userDetails', 'UserDetails', 'user_id'],
  'externalusers/external_user_id': ['settings', 'SettingsStore', 'externalUserList', 'externalUserDetails', 'ExternalUserDetails', 'external_user_id'],
  'accounts/account_id': ['distribution', 'DistributionStore', 'accountListGPTContext', 'distributionAccountDetailsGPTContext', 'DistributionAccountDetails', 'account_id'],
  'orders/order_id': ['distribution', 'DistributionStore', 'distributionOrderList', 'distributionOrderDetails', 'DistributionOrderDetails', 'order_id'],
  'suppliers/supplier_id': ['distribution', 'DistributionStore', 'supplierList', 'supplierDetails', 'SupplierDetails', 'supplier_id'],
  'statement_list/statement_id': ['distribution', 'DistributionStore', 'distributionStatementList', 'distributionStatementDetails', 'DistributionStatementsDetails', 'statement_id'],
  'shops/shop_id': ['distribution', 'DistributionStore', 'shopList', 'shopDetails', 'ShopDetails', 'shop_id'],
  'shop_groups/shop_group_id': ['distribution', 'DistributionStore', 'shop_groupList', 'shop_groupDetails', 'Shop_groupDetails', 'shop_group_id'],
  'supplier_order/supplier_order_id': ['distribution', 'DistributionStore', 'distributionSupplierOrderList', 'distributionSupplierOrderDetails', 'DistributionSupplierOrderDetails', 'supplier_order_id'],
  'catalog_artists/label_artist_id': ['catalog', 'LabelStore', 'artistsList', 'artistDetails', 'CatalogArtistsDetails', 'label_artist_id'],
  'labels/label_id': ['catalog', 'LabelStore', 'labelList', 'labelDetails', 'LabelDetails', 'label_id'],
  'projects/project_id': ['catalog', 'LabelStore', 'projectList', 'projectDetails'],
  'releases/release_id': ['catalog', 'LabelStore', 'releasesCatalogData', 'releaseDetails', 'ReleaseDetails', 'release_id'],
  'products/product_id': ['catalog', 'LabelStore', 'productListGPTContext', 'productDetails', 'ProductDetails', 'product_id'],
  'tracks/track_id': ['catalog', 'LabelStore', 'trackList', 'trackDetails', 'TrackDetails', 'track_id'],
  'product_groups/product_group_id': ['catalog', 'LabelStore', 'product_groupsList', 'product_groupDetails', 'Product_groupDetails', 'product_group_id'],
  'royalty_accounts/royalty_account_id': ['royalty', 'RoyaltyStore', 'accountsList', 'accountsDetails', 'AccountsDetails', 'royalty_account_id'],
  'contracts/contract_id': ['royalty', 'RoyaltyStore', 'contractsList', 'contractsDetails', 'ContractsDetails', 'contract_id'],
  'statements/royalty_period_id': ['royalty', 'RoyaltyStore', 'statementList', 'statementDetails', 'StatementDetails', 'royalty_period_id'],
  'licence_accounts/licence_account_id': ['licencing', 'LicenceStore', 'licenceAccountsList', 'licenceAccountsDetails', 'LicenceAccountsDetails', 'licence_account_id'],
  'licences/licence_id': ['licencing', 'LicenceStore', 'licencesList', 'licencesDetails', 'LicenceDetails', 'licence_id'],
  'tasks/task_id': ['task', 'TaskStore', 'tasksList', 'tasksDetails', 'TasksDetails', 'task_id']
};

const findGettersFromRoute = (routeName) => {
  console.log("Received routeName:", routeName);

  const isList = routeName?.split('/').length === 1;

  const trimDetails = routeName?.split('/')?.[0];
  const trimDetailsKey = Object.keys(routeGetterMap).find(key => key?.split('/')?.[0] === trimDetails);

  const withTab = routeName.includes('/tab');
  console.log("withTab:", withTab);

  const trimTab = routeName.replace('/tab', '');
  console.log({
    isList,
    'trimDetails': trimDetails, trimDetailsKey, routeGetterMap, routeTr: routeGetterMap[trimDetailsKey],

    routeTrL: routeGetterMap[trimDetailsKey]?.[2],
  });
  console.log("trimTab:", trimTab);

  const getterKey = isList ? routeGetterMap[trimDetailsKey]?.[2] : routeGetterMap[trimDetailsKey]?.[3];
  console.log("getterKey:", getterKey);

  if (getterKey) {
    const result = `${routeGetterMap[trimDetailsKey]?.[1]}/${getterKey}`;
    console.log("Resulting path:", result);
    return result;
  }

  console.log("Defaulting to 'account'");
  return 'account';
}


function replaceTemplateParams(template, params) {
  return template.replace(/<([^>]+)>/g, (match, key) => {
    return key in params ? params[key] : '';
  });
}


export const DtGPTDetailsAPIService = {
  async httpGet(endpoint, params) {
    console.log({ 'dt-gpt.service.js:95 params': params });
    // const url = replaceTemplateParams(`/${endpoint}`, params);
    return MHTTPCL.get2(endpoint, params);
    // return MHTTPCL.get2(endpoint, params);
  }
}



const mapObject = (data, mapper) => {
  const result = {};
  for (const key in mapper) {
    const path = mapper[key].split('.');
    let value = data;
    for (const p of path) {
      if (value && typeof value === 'object' && p in value) {
        value = value[p];
      } else {
        value = undefined;
        break;
      }
    }
    result[key] = value;
  }
  return result;
}
